import { useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { detailProjects } from 'data';
import Container from 'components/Container';
import HeadingTwo from 'components/HeadingTwo';
import ImageClickMe from 'components/imageClickMe';
import ImageMac from 'components/imageMac';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from 'react-helmet-async';
import { useFollowPointer } from "hook/useFollowPointer";

interface RouteParams {
    [key: string]: string | undefined;
    id?: string;
}

function PortfolioDetail() {
    const { id } = useParams<RouteParams>();
    const navigate = useNavigate();


    useEffect(() => {
        if (!id) {
            navigate("/404");
            return;
        }

        const data = detailProjects.find((item) => item.title === id);

        if (!data) {
            navigate("/404");
        }
    }, [id, navigate]);

    const data = detailProjects.find(item => item.title === id);

    const ref = useRef<HTMLDivElement | null>(null);
    const { x, y } = useFollowPointer(ref);

    return (
        <>
            <Helmet>
                <title>{data?.title}• FRONTEND DEVELOPER</title>
                <meta name="description" content="" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            </Helmet>
            <Container className="pb-6 md:pb-12 min-h-[80vh] md:min-h-[unset]">
                <div className="w-[340px] sm:w-[480px] lg:w-[740px] xl:w-[900px] 2xl:w-[840px] 4xl:w-[1500px] mx-auto mt-32 md:mt-48 4xl:mt-[440px] lg:mb-6">
                    <HeadingTwo className='mb-8 capitalize'>
                        {id}
                    </HeadingTwo>
                    <div className="grid lg:grid-cols-3 gap-6">
                        <div className="">
                            <p className='mb-4 border-b border-smoke border-opacity-30 text-smoke text-justify font-medium text-xl leading-tight md:text-2xl lg:text-xl xl:text-2xl'>ROLE</p>
                            <p className='text-smoke text-justify font-light text-xl leading-tight md:text-2xl lg:text-xl xl:text-2xl '>
                                {data?.role}
                            </p>
                        </div>
                        {data?.link && (
                            <div className="relative w-[80%] md:w-[60%]">
                                <p className='mb-4 border-b border-smoke border-opacity-30 text-smoke text-justify font-medium text-xl leading-tight md:text-2xl lg:text-xl xl:text-2xl'>DATE</p>
                                <p className='text-smoke text-justify font-light text-xl leading-tight md:text-2xl lg:text-xl xl:text-2xl '>
                                    {data?.year}
                                </p>
                                <div className="absolute right-0 top-0 bg-lemone rounded-full p-2">
                                    <motion.div className="w-[64px] h-[64px]relative  "
                                        whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }}>
                                        <motion.svg xmlns="http://www.w3.org/2000/svg" className="w-full h-full" viewBox="0 0 100 100"
                                            animate={{ rotate: 360 }}
                                            transition={{ duration: 8, ease: "linear", repeat: Infinity }}
                                        >
                                            <defs>
                                                <path id="circle"
                                                    d="
M 50, 50
m -37, 0
a 37,37 0 1,1 74,0
a 37,37 0 1,1 -74,0"/>
                                            </defs>
                                            <text className="text-[16px] md:text-[17px] tracking-[.2em] lg:tracking-widest">
                                                <textPath href="#circle">
                                                    Live Site - Click Me  -
                                                </textPath>
                                            </text>
                                        </motion.svg>
                                        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
                                            <a href={data?.link}
                                                className="w-[34px] h-[34px] text-2xl md:text-[1.75rem] flex justify-center items-center bg-smoke text-neutral-100 rounded-full">
                                                <FontAwesomeIcon icon={faEye} />
                                            </a>
                                        </div>
                                    </motion.div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Container>
            <ImageClickMe image={data?.image} link={data?.link} />
            {data?.image && (
                <ImageMac image={data?.mac} />
            )}
        </>
    );
}

export default PortfolioDetail;